exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.upload-box[data-v-4c5d9a0f] {\n  display: inline-block;\n  border: 1px dashed #c0ccda;\n  border-radius: 6px;\n  cursor: pointer;\n  overflow: hidden;\n  width: 148px;\n  height: 148px;\n  line-height: 145px;\n  margin-top: 20px;\n  text-align: center;\n}\n.upload-box .avatar-uploader-icon[data-v-4c5d9a0f] {\n    font-size: 38px;\n}\n.upload-box .pic[data-v-4c5d9a0f] {\n    max-width: 148px;\n    max-height: 148px;\n    vertical-align: middle;\n}\n.alert-text[data-v-4c5d9a0f] {\n  padding: 0 20px;\n  margin-bottom: 20px;\n}\n.gap-text[data-v-4c5d9a0f] {\n  margin-top: 20px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-4c5d9a0f","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/theme.scss","/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/_mixin.scss"]}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/view/popularize/setting.vue
// module id = 1443
// module chunks = 0